import {
  type CreateMarkupProfileRequest,
  type MarkupProfileDetail,
  MarkupProfileDetailSchema,
  type MarkupProfileListQuery,
  type MarkupProfileListResponse,
  MarkupProfileListResponseSchema,
  type UpdateMarkupProfileRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Markup profiles master API (Pricing → Markup Profiles). The quote-engine
 * markup master applied during itinerary pricing. Responses are validated with
 * the shared Zod schema.
 */

export const listMarkupProfiles = async (
  query: MarkupProfileListQuery,
): Promise<MarkupProfileListResponse> => {
  const { data } = await apiClient.get<unknown>('/markup-profiles', { params: query });
  return MarkupProfileListResponseSchema.parse(data);
};

export const getMarkupProfile = async (id: string): Promise<MarkupProfileDetail> => {
  const { data } = await apiClient.get<unknown>(`/markup-profiles/${id}`);
  return MarkupProfileDetailSchema.parse(data);
};

export const createMarkupProfile = async (
  payload: CreateMarkupProfileRequest,
): Promise<MarkupProfileDetail> => {
  const { data } = await apiClient.post<unknown>('/markup-profiles', payload);
  return MarkupProfileDetailSchema.parse(data);
};

export const updateMarkupProfile = async (
  id: string,
  payload: UpdateMarkupProfileRequest,
): Promise<MarkupProfileDetail> => {
  const { data } = await apiClient.patch<unknown>(`/markup-profiles/${id}`, payload);
  return MarkupProfileDetailSchema.parse(data);
};

export const deleteMarkupProfile = async (id: string): Promise<void> => {
  await apiClient.delete(`/markup-profiles/${id}`);
};
